import React from 'react';
import styled from 'styled-components';
import Select from '../select/dropdown';

const Employees = ({
  className,
  employees,
  ...props
}) => {
  const values = (employees || []).map(({ name }) => ({
    value: name,
  }));
  return (
    <Select
      className={className}
      values={values}
      {...props}
      defaultOptionTitle="Kies een medewerker..."
      alwaysShowDefaultOption
    />
  );
};

export default styled(Employees)``;
